import { kebabToTitleCase, toTitleCase } from "~/lib/format";
import compact from "lodash/compact";
import { SportResult } from "~/lib/api/ecosystemV2.server";

export function shortName(division: string): string {
    switch (division) {
        case "NCAA Division 1 - FBS":
        case "NCAA Division I - FBS":
            return "FBS";
        case "NCAA Division 1 - FCS":
        case "NCAA Division I - FCS":
            return "FCS";
        case "NCAA Division 1":
        case "NCAA Division I":
            return "D1";
        case "NCAA Division 2":
        case "NCAA Division II":
            return "D2";
        case "NCAA Division 3":
        case "NCAA Division III":
            return "D3";
        case "Other":
        case "NAIA":
        case "JUCO":
        case "Club":
        default:
            return division;
    }
}

export function location({
    attrs: data,
}: {
    attrs: {
        city: string;
        state_code: string;
    };
}): string {
    const state = data.state_code.toLocaleUpperCase();
    if (data.city && !!data.city.length) {
        return `${toTitleCase(data.city)}, ${state}`;
    } else {
        return state;
    }
}

function locationsDisplayText(states: string[], metros: string[]): string | undefined {
    if (states.length > 0 && metros.length > 0) return undefined;
    if (states.length === 1) return `In ${states[0]}`;
    if (metros.length === 1 && metros[0]) return `In ${kebabToTitleCase(metros[0])}`;
    return undefined;
}
export function header(
    sport: string,
    divisions: string[],
    locationStates: string[],
    locationMetros: string[],
) {
    const sportText = toTitleCase(sport);
    const divisionText =
        divisions.length === 1 && divisions[0] ? shortName(divisions[0]) : undefined;
    return compact([
        divisionText,
        sportText,
        "Colleges",
        locationsDisplayText(locationStates, locationMetros),
    ]).join(" ");
}

export function gender(value: string) {
    switch (value) {
        case "mens":
            return "Men's";
        case "womens":
            return "Women's";
        case "mixed":
            return "Coed";
        default:
            return value.toLocaleUpperCase();
    }
}

export function height(inches: number) {
    const feet = Math.floor(inches / 12);
    const remainder = inches % 12;
    return `${feet}-${remainder}`;
}

export function sports(values: SportResult[] | undefined) {
    return values
        ?.map(s => s.attrs.name.replace(/(wo)*men's\s/gi, ""))
        .sort()
        .join(", ");
}
